import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { calculateInputSelection, namespacedClassnames } from '../../../../common';
import { Tooltip } from '../../../../primitives/tooltip/tooltip';
export var textInputKey = 'text-input';
var TextInput = /** @class */ (function (_super) {
    __extends(TextInput, _super);
    function TextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (e) {
            var props = _this.props;
            if (!props.disabled) {
                props.onChange(e.target.value, e);
            }
        };
        _this.onSelect = function (e) {
            if (_this.props.onSelect) {
                var t = e.target;
                var selection = calculateInputSelection(t);
                _this.props.onSelect(selection);
            }
        };
        return _this;
    }
    TextInput.prototype.render = function () {
        var _a = this.props, type = _a.type, disabled = _a.disabled, props = __rest(_a, ["type", "disabled"]);
        var cn = namespacedClassnames(textInputKey, props.className, { disabled: !!disabled });
        var textInputProps = __assign(__assign({}, props), { className: cn, type: type || 'text', disabled: !!disabled, onChange: this.onChange, onSelect: this.onSelect });
        var body = React.createElement("input", __assign({}, textInputProps));
        return !!disabled && typeof disabled === 'string' ? (React.createElement(Tooltip, { body: disabled, relativeToBody: true, className: this.props.tooltipClassName }, body)) : body;
    };
    return TextInput;
}(React.PureComponent));
export { TextInput };
//# sourceMappingURL=index.js.map